import React, { useEffect, useState } from "react"
import {
  getKOL,
  requestKOLCrawler,
} from "../../HelpingFunction/KOL/kolDBHelper"
import { useHistory, useLocation, useParams } from "react-router-dom"
import KOL from "../../Model/KOL"
import { getFollowersData } from "../../HelpingFunction/FollowersData/FollowerDBHelper"
import { IG_USER_DATA } from "../../Enum/LOGIN_PAGE_TYPE"
import AboutKOL from "../../page-components/p/AboutKOL"
import { useDispatch, useSelector } from "react-redux"
import { SUPPORTED_REDUX_FUNCTIONS } from "../../Redux/SUPPORTED_REDUX_FUNCTION"
import classNames from "classnames"

import { Trans, useTranslation } from "react-i18next"
import { isAuth } from "../../Utils/FirebaseUtils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHeart } from "@fortawesome/free-regular-svg-icons"
import {
  faCheck,
  faHeart as faHeartSolid,
  faShare,
} from "@fortawesome/free-solid-svg-icons"
import { getUserLang, toggleShare } from "../../Utils/utiltyHelper"
import { isKOLBookmarked } from "../../HelpingFunction/Member/memberDBHelper"

import KOLInsights from "../../page-components/p/KOLInsights"
import KOLWork from "../../page-components/p/KOLWork"
import KOLReviews from "../../page-components/p/KOLReviews"
import KOLSimilar from "../../page-components/p/KOLSimilar"

import AboutKOLLoading from "../../page-components/p/AboutKOLLoading"
import KOLInsightsLoading from "../../page-components/p/KOLInsightsLoading"
import KOLWorkLoading from "../../page-components/p/KOLWorkLoading"
import { Helmet } from "react-helmet"
import { returnBreadcrumbList } from "../../Utils/SEOTools/IDJson"
import { getAuthUID } from "../../Utils/QueryHelper"
import { analytics } from "../../Config/firebase"
import { logEvent } from "firebase/analytics"

const Id = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const auth = useSelector((state: any) => {
    return state.firebase.auth
  })
  const params = useParams<{
    id: string
    type?: string
    lang: string
  }>()

  let query = useLocation()
  const history = useHistory()

  const paramList = useSelector((state: any) => {
    return state.QueryManager.params
  })

  const screenWidth = useSelector((state: any) => {
    return state.SystemManager.screenWidth
  })

  const kolInfo = useSelector((state: any) => {
    return state.KOLInfoManager.kolInfo
  })

  const [type, setType] = useState<string>("")
  const [isLoadedProfile, setIsLoadedProfile] = useState<boolean>(false)
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false)
  const [isShare, setIsShare] = useState<boolean>(false)

  const setKOLProfile = (kol: KOL) => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.SET_KOL_INFO,
      data: kol,
    })
  }
  const setIGUserData = (igUserData: IG_USER_DATA) => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.SET_IG_USER_DATA,
      data: igUserData,
    })
  }

  const setMemberBookmark = (state: any) => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.BOOK_MARK_KOL,
      uid: state.uid,
      kolID: state.kolID,
    })
  }
  const setKOLInfo = (state: any) => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.SET_KOL_INFO,
      kolInfo: state,
    })
  }

  const checkMember = async () => {
    await isKOLBookmarked(auth.uid, kolInfo.id).then((res) => {
      if (res.success) {
        setIsBookmarked(res.bookmarked)
      } else {
        setIsBookmarked(false)
      }
    })
  }

  const trimToLastFullStop = (text: string) => {
    if (text) {
      const lI = text.slice(0, 169).lastIndexOf("。")
      if (lI !== -1) {
        return text.substring(0, lI + 1)
      }
      return text
    }
    return ""
  }

  const shareKOL = async () => {
    toggleShare({
      title: t("ShareModal.share-title"),
      text:
        t("ShareModal.share-mobile-title") +
        " " +
        kolInfo.userName +
        t("ShareModal.share-mobile-desc"),
      url: window.location.href,
    }).then((result) => {
      setIsShare(result.success)
    })
  }

  useEffect(() => {
    setIsLoadedProfile(false)

    getKOL(params.id)
      .then((result) => {
        if (result.success) {
          logEvent(analytics, "kolProfile_visit", {
            kolID: result.data.id,
          })

          setKOLProfile(result.data)
          let kolUID = result.data.id
          //update from crawler
          requestKOLCrawler(kolUID)

          //get ig data
          getFollowersData(kolUID, "ig").then((res) => {
            if (res.success) {
              if (res.igData) {
                setIGUserData(res.igData as IG_USER_DATA)
              }
            }
          })
          setIsLoadedProfile(true)
        } else {
          //if kol not found or not yet published
          history.push("/" + params.lang)
        }
      })
      .catch((err) => console.error(err))
  }, [params.id])

  useEffect(() => {
    const typeQuery = new URLSearchParams(query.search).get("type")
    if (typeQuery) {
      setType(typeQuery)
    } else if (screenWidth < 768) {
      setType("")
    } else {
      setType("stat")
    }
  }, [query])

  useEffect(() => {
    setKOLInfo({
      id: kolInfo.id,
      avatarUrl: kolInfo.avatarUrl,
      userName: kolInfo.userName,
      isBookmarked: isBookmarked,
    })
  }, [isBookmarked])

  useEffect(() => {
    if (isAuth(auth)) {
      checkMember()
    }
  }, [auth])

  if (isLoadedProfile && screenWidth >= 768) {
    //desktop
    return (
      <>
        {/* SEO tag*/}
        <Helmet>
          <title>
            {kolInfo.userName +
              ` (@${kolInfo.userName})` +
              " | " +
              t("Feature.l4k")}
          </title>
          <meta property="fb:app_id" content="3080771285488915" />
          <meta property="og:type" content="website" />
          <meta property="site_name" content="look4kol" />
          <meta
            property="title"
            content={kolInfo.userName + " | " + t("Feature.title")}
          />
          <meta
            name="description"
            content={
              kolInfo.userName + " - " + kolInfo.metaDesc === undefined
                ? kolInfo.description
                : trimToLastFullStop(kolInfo.metaDesc)
            }
          />
          {/*<meta name="keywords"*/}
          {/*      content={t("HomePage.keywords")}/>*/}
          <meta
            property="og:title"
            content={kolInfo.userName + " | " + t("Feature.title")}
          />
          <meta
            property="og:description"
            content={
              kolInfo.userName + " - " + kolInfo.metaDesc === undefined
                ? kolInfo.description
                : kolInfo.metaDesc
            }
          />
          <meta
            property="og:image"
            content={
              Array.isArray(kolInfo.coverImages) ? kolInfo.coverImages[0] : ""
            }
          />

          <meta
            property="og:url"
            content={
              process.env.REACT_APP_HOST_NAME +
              "/" +
              params.lang +
              "/p/" +
              kolInfo.userName
            }
          />
          <link
            rel="canonical"
            href={
              params.lang === "en"
                ? process.env.REACT_APP_HOST_NAME + "/en/p/" + kolInfo.userName
                : process.env.REACT_APP_HOST_NAME + "/hk/p/" + kolInfo.userName
            }
          />
          <link
            rel="alternate"
            hrefLang={params.lang === "en" ? "zh-HK" : "en"}
            href={
              params.lang === "en"
                ? process.env.REACT_APP_HOST_NAME + "/hk/p/" + kolInfo.userName
                : process.env.REACT_APP_HOST_NAME + "/en/p/" + kolInfo.userName
            }
          />

          <script type="application/ld+json">
            {JSON.stringify(
              returnBreadcrumbList(params.lang, {
                child: {
                  name: kolInfo.userName,
                  path: "p/" + kolInfo.userName,
                },
              })
            )}
          </script>
        </Helmet>

        {/* Main Container*/}
        <div className="safe-are-detection-bottom w-full md:bg-gray-200">
          <div className="md:grid md:grid-cols-12">
            <div className="md:col-span-5 lg:col-span-4 md:border-r w-full md:px-0 px-2">
              <hr className="md:hidden inline-block" />
              <AboutKOL />
            </div>

            <div className="hidden md:inline-block md:col-span-7 lg:col-span-8 h-full text-center p-4 bg-white rounded-l-xl pb-12">
              {/* Tab*/}
              <div className="hidden md:inline-block tabs tabs-boxed bg-gray-100 gap-8 mx-auto mb-2 ">
                <a
                  onClick={() => {
                    history.push({
                      pathname: "/" + params.lang + "/p/" + params.id,
                      search: "?" + new URLSearchParams({ type: "stat" }),
                    })
                  }}
                  className={classNames("tab text-md h-10", {
                    "tab-active font-bold": type === "stat",
                  })}>
                  <Trans>KOLProfile.insights</Trans>
                </a>
                <a
                  onClick={() => {
                    history.push({
                      pathname: "/" + params.lang + "/p/" + params.id,
                      search: "?" + new URLSearchParams({ type: "case" }),
                    })
                  }}
                  className={classNames("tab text-md h-10", {
                    "tab-active font-bold": type === "case",
                  })}>
                  <Trans>KOLProfile.work</Trans>
                </a>
                <a
                  onClick={() => {
                    history.push({
                      pathname: "/" + params.lang + "/p/" + params.id,
                      search: "?" + new URLSearchParams({ type: "similar" }),
                    })
                  }}
                  className={classNames("tab text-md h-10", {
                    "tab-active font-bold": type === "similar",
                  })}>
                  <Trans>KOLProfile.similar</Trans>
                </a>
              </div>
              {isAuth(auth) && getAuthUID(paramList) !== kolInfo.id ? (
                <div className="float-right">
                  <div className="flex flex-row gap-4 text-lg items-center">
                    {/*<button*/}
                    {/*  onClick={() => {*/}
                    {/*    history.push(*/}
                    {/*      "/" +*/}
                    {/*        getUserLang() +*/}
                    {/*        "/p/" +*/}
                    {/*        params.id +*/}
                    {/*        "?type=recommend"*/}
                    {/*    )*/}
                    {/*  }}*/}
                    {/*  className={classNames("btn btn-xs btn-primary", {*/}
                    {/*    " no-animation": type === "recommend",*/}
                    {/*    "btn-outline": type !== "recommend",*/}
                    {/*  })}>*/}
                    {/*  <Trans>KOLProfile.recommend</Trans> +*/}
                    {/*</button>*/}
                    <div
                      className={
                        isBookmarked
                          ? "text-red-400 cursor-pointer"
                          : "text-gray-600 cursor-pointer"
                      }
                      onClick={() => {
                        if (isAuth(auth)) {
                          if (isBookmarked) {
                            setIsBookmarked(false)
                            setMemberBookmark({
                              uid: auth.uid,
                              kolID: kolInfo.id,
                            })
                          } else {
                            setIsBookmarked(true)
                            setMemberBookmark({
                              uid: auth.uid,
                              kolID: kolInfo.id,
                            })
                          }
                        } else {
                          history.push("/" + params.lang + "/login")
                        }
                      }}>
                      <FontAwesomeIcon
                        icon={isBookmarked ? faHeartSolid : faHeart}
                      />
                    </div>
                    <div
                      onClick={() => shareKOL()}
                      className="text-gray-600 cursor-pointer">
                      {isShare ? (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="justify-center"
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faShare}
                          className="justify-center"
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : null}

              <div
                className={classNames({
                  hidden: type !== "stat",
                })}>
                <KOLInsights />
              </div>
              <div
                className={classNames({
                  hidden: type !== "case",
                })}>
                <KOLWork type={type} />
              </div>
              <div
                className={classNames({
                  hidden: type !== "similar",
                })}>
                <KOLSimilar />
              </div>
              {/*<div*/}
              {/*  className={classNames({*/}
              {/*    hidden: type !== "review",*/}
              {/*  })}>*/}
              {/*  <KOLReviews />*/}
              {/*</div>*/}
              {/*<div*/}
              {/*  className={classNames({*/}
              {/*    hidden: type !== "recommend",*/}
              {/*  })}>*/}
              {/*  <KOLRecommendations />*/}
              {/*</div>*/}
            </div>
          </div>
        </div>
      </>
    )
  } else if (isLoadedProfile && screenWidth < 768) {
    //mobile
    return (
      <div>
        <div
          className={classNames({
            hidden: type !== "",
          })}>
          <AboutKOL />
        </div>
        <div
          className={classNames({
            hidden: type !== "stat",
          })}>
          <KOLInsights />
        </div>
        <div
          className={classNames({
            hidden: type !== "case",
          })}>
          <KOLWork type={type} />
        </div>
        <div
          className={classNames({
            hidden: type !== "similar",
          })}>
          <KOLSimilar />
        </div>
        {/*<div*/}
        {/*  className={classNames({*/}
        {/*    hidden: type !== "review",*/}
        {/*  })}>*/}
        {/*  <KOLReviews />*/}
        {/*</div>*/}
        {/*<div*/}
        {/*  className={classNames({*/}
        {/*    hidden: type !== "recommend",*/}
        {/*  })}>*/}
        {/*  <KOLRecommendations />*/}
        {/*</div>*/}
      </div>
    )
  } else if (!isLoadedProfile && screenWidth < 768) {
    return (
      <div>
        <div
          className={classNames({
            hidden: type !== "",
          })}>
          <AboutKOLLoading />
        </div>
        <div
          className={classNames({
            hidden: type !== "stat",
          })}>
          <KOLInsightsLoading />
        </div>
        <div
          className={classNames({
            hidden: type !== "case",
          })}>
          <KOLWorkLoading />
        </div>
        {/*<div*/}
        {/*  className={classNames({*/}
        {/*    hidden: type !== "recommend",*/}
        {/*  })}>*/}
        {/*  <KOLRecommendations />*/}
        {/*</div>*/}
      </div>
    )
  }
  return (
    <div className="w-full md:bg-gray-200">
      <div className="md:grid md:grid-cols-12">
        <div className="md:col-span-5 lg:col-span-4 md:border-r w-full md:px-0 px-2">
          <hr className="md:hidden inline-block" />
          <AboutKOLLoading />
        </div>

        <div className="hidden md:inline-block md:col-span-7 lg:col-span-8 h-full text-center p-4 bg-white rounded-l-xl">
          {/* Tab*/}
          <div className="hidden md:inline-block tabs tabs-boxed bg-gray-100 gap-8 mx-auto mb-2 ">
            <a
              className={classNames("tab text-md h-10", {
                "tab-active font-bold": type === "stat",
              })}>
              <Trans>KOLProfile.insights</Trans>
            </a>
            <a
              className={classNames("tab text-md h-10", {
                "tab-active font-bold": type === "case",
              })}>
              <Trans>KOLProfile.work</Trans>
            </a>
            <a
              className={classNames("tab text-md h-10", {
                "tab-active font-bold": type === "similar",
              })}>
              <Trans>KOLProfile.similar</Trans>
            </a>
            {/*<a*/}
            {/*  className={classNames("tab text-md h-10", {*/}
            {/*    "tab-active font-bold": type === "recommend",*/}
            {/*  })}>*/}
            {/*  <Trans>KOLProfile.recommend</Trans>*/}
            {/*</a>*/}
          </div>

          <div className="float-right">
            <div className="flex flex-row gap-4 text-lg items-center">
              {/*<button*/}
              {/*  onClick={() => {*/}
              {/*    history.push(*/}
              {/*      "/" + getUserLang() + "/p/" + params.id + "?type=recommend"*/}
              {/*    )*/}
              {/*  }}*/}
              {/*  className={classNames("btn btn-xs btn-primary", {*/}
              {/*    " no-animation": type === "recommend",*/}
              {/*    "btn-outline": type !== "recommend",*/}
              {/*  })}>*/}
              {/*  <Trans>KOLProfile.recommend</Trans> +*/}
              {/*</button>*/}
            </div>
          </div>

          <div
            className={classNames({
              hidden: type !== "",
            })}>
            <AboutKOL />
          </div>
          <div
            className={classNames({
              hidden: type !== "stat",
            })}>
            <KOLInsights />
          </div>
          <div
            className={classNames({
              hidden: type !== "case",
            })}>
            <KOLWork type={type} />
          </div>
          <div
            className={classNames({
              hidden: type !== "similar",
            })}>
            <KOLSimilar />
          </div>
          {/*<div*/}
          {/*  className={classNames({*/}
          {/*    hidden: type !== "review",*/}
          {/*  })}>*/}
          {/*  <KOLReviews />*/}
          {/*</div>*/}
          {/*<div*/}
          {/*  className={classNames({*/}
          {/*    hidden: type !== "recommend",*/}
          {/*  })}>*/}
          {/*  <KOLRecommendations />*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  )
}

export default Id
